import { render } from "./ModalScanWallettoken.vue?vue&type=template&id=672d5a9a&scoped=true"
import script from "./ModalScanWallettoken.vue?vue&type=script&lang=js"
export * from "./ModalScanWallettoken.vue?vue&type=script&lang=js"

import "./ModalScanWallettoken.vue?vue&type=style&index=0&id=672d5a9a&scoped=true&lang=css"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672d5a9a"]])

export default __exports__